import {OutsourcedStatics} from "../../config/OutsourcedStatics";
import {gsap} from "gsap";
import {OutsourcedGameAssets} from "../../OutsourcedGameAssets";
import {Outsourced} from "../../Outsourced";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {ReelView} from "../../../core/reel/simplereel/SimpleReelModel";

export interface SymbolArgs {
    symbolName:string;
    reelPosition:number;
    reelID:number;
}

export class OutsourcedSymbol extends PIXI.Container {
    public winAnimation:PIXI.spine.Spine;
    public mainSprite:PIXI.Sprite;
    public spinSprite:PIXI.Sprite;
    public winBlink:PIXI.Sprite;
    public symbolName:string;
    public reelPosition:number;
    public reelID:number;
    scatterSpine:PIXI.spine.Spine;
    alreadyAnticipating:boolean;

    constructor(args:SymbolArgs) {
        super();
        this.reelPosition = args.reelPosition;
        this.reelID = args.reelID;
        this.symbolName = args.symbolName;

        this.mainSprite =new PIXI.Sprite(Outsourced.assetLoader.getTextures(OutsourcedGameAssets.getSymbolStateTexturePath(this.symbolName))[0]);
        this.mainSprite.anchor.set(0.5,0.5);
        this.addChild(this.mainSprite);

        this.spinSprite = new PIXI.Sprite(Outsourced.assetLoader.getTextures(OutsourcedGameAssets.getSymbolStateTexturePath(this.symbolName, "_spin"))[0]);
        this.spinSprite.anchor.set(0.5,0.5);
        this.spinSprite.alpha = 0;
        this.addChild(this.spinSprite);
    }

    public crossFadeFromSpin(duration:number = 1):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.mainSprite, {alpha: 1, duration: duration}));
    }

    public crossFadeIntoSpin(duration:number = 1):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.mainSprite, {alpha: 0, duration: duration}));
    }

    public setNoWin():gsap.core.Timeline {
       return gsap.timeline().add(gsap.to(this, {alpha: 0.5, duration: 0.1}));
    }

    public setNormal():gsap.core.Timeline {
        return gsap.timeline().add(gsap.to(this, {alpha: 1.0, duration: 0.1}));
    }

    public getWinBlink():gsap.core.Timeline {
        if (this.winBlink == undefined) {
            const blinkName = (this.symbolName == "MAX" || this.symbolName == "XN") ? "XN_MAX" : this.symbolName
            this.winBlink = new PIXI.Sprite(Outsourced.assetLoader.getTextures(`SYM_Blink/${blinkName}_Blink`)[0]);
            this.winBlink.anchor.set(0.5,0.5);
            this.winBlink.alpha = 0;
            this.winBlink.blendMode = PIXI.BLEND_MODES.ADD;
            this.addChild(this.winBlink);
        }
        return gsap.timeline()
            .add(() => {this.winBlink.alpha = 1})
            .add(gsap.to(this.winBlink, {alpha: 0, duration: 0.08}), '>0.08');
    }

    public getWinAnimation():gsap.core.Timeline {
        if (this.winAnimation == undefined) {
            this.winAnimation = new PIXI.spine.Spine(Outsourced.assetLoader.getSpineAsset(OutsourcedGameAssets.SYM_WIN));
            this.winAnimation.visible = false;
            this.addChildAt(this.winAnimation, 1);
        }

        const winAnimation= this.symbolName == "MAX" ? `MAX_${this.reelID + 1}_Win` : `${this.symbolName}_Win`;

        return gsap.timeline()
            .add(() => {
                this.winAnimation.visible = true;
            })
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, winAnimation))
            .add(() => {
                this.winAnimation.visible = false;
            });
    }

    public getLandAnimation():gsap.core.Timeline {
        return this.getWinBlink();
    }

    public setSpinning(instant:boolean = false) {
        const tl = gsap.timeline()
            .add(gsap.to(this.spinSprite, {alpha: 1, duration: 0.1}))
            .add(gsap.to(this.mainSprite, {alpha: 0, duration: 0.1}))

        if (instant)
            tl.progress(1);

        return tl;
    }

    public setStill(instant:boolean = false) {
        const tl = gsap.timeline()
            .add(gsap.to(this.spinSprite, {alpha: 0, duration: 0.1}))
            .add(gsap.to(this.mainSprite, {alpha: 1, duration: 0.1}))

        if (instant)
            tl.progress(1);

        return tl;
    }

    startScatterAnticipation() {
        if (this.symbolName != "SC" || this.alreadyAnticipating)
            return;

        if (this.scatterSpine == undefined) {
            this.scatterSpine = new PIXI.spine.Spine(Outsourced.assetLoader.getSpineAsset(OutsourcedGameAssets.SCATTER));
            this.addChild(this.scatterSpine);
        }

        this.scatterSpine.state.setAnimation(0, "SC_Anticipation", true);
        this.alreadyAnticipating = true;
    }

    stopScatterAnticipation() {
        if (this.symbolName != "SC" || this.scatterSpine == undefined)
            return;

        this.alreadyAnticipating = false;
        this.scatterSpine.state.setEmptyAnimation(0, 0);
    }
}